<template>
    <v-expansion-panels v-model="panel">
        <v-expansion-panel >
            <v-expansion-panel-header class="headline">{{ $t('filters') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                    <v-col class="col-12 col-sm-4 d-flex justify-center">
                        <v-autocomplete
                            v-model="activeFilters.category_id"
                            :label="categories.label"
                            :items="categories.valuesData"
                            item-text="name"
                            item-value="id"
                            @change="filterChange"
                            hide-no-data
                            clearable
                            multiple
                            color="teal lighten-2"
                            item-color="teal lighten-2"
                        ></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-sm-4 d-flex justify-center">
                        <v-autocomplete
                            v-model="activeFilters.enum_attribute_id"
                            :label="enumAttributes.label"
                            :items="enumAttributes.valuesData"
                            item-text="name"
                            item-value="id"
                            @change="filterChange"
                            hide-no-data
                            clearable
                            multiple
                            color="teal lighten-2"
                            item-color="teal lighten-2"
                        ></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-sm-4 d-flex justify-center">
                        <v-autocomplete
                            v-model="activeFilters.enum_attribute_value_id"
                            :label="enumAttributesValues.label"
                            :items="enumAttributesValues.valuesData"
                            item-text="name"
                            item-value="id"
                            @change="filterChange"
                            hide-no-data
                            clearable
                            multiple
                            color="teal lighten-2"
                            item-color="teal lighten-2"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import { MixinFiltersGeneral } from  '../../mixins'
import {FilterService} from "../../services";

export default {
    name: "AttributesFilters",
    mixins: [ MixinFiltersGeneral ],
    data() {
        return {
            panel: null,
            activeFilters: {},
            layout:[],
        }
    },
    computed: {
        categories() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.categoryID.systemName);
            return filter || {};
        },
        enumAttributes() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.enumAttributeID.systemName);
            return filter || {};
        },
        enumAttributesValues() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.enumAttributeValueID.systemName);
            return filter || {};
        },
        updateFilters() {
            return this.$store.getters.updateAttributesFilters;
        }
    },
    methods: {
        getLayout() {
            this.setFiltersFromUrl();
            FilterService.setAuth(this.$store.getters.token);
            return FilterService.getAttributesLayout()
                .then(res => {
                    this.layout = [...res.data];
                })
                .catch(err => {console.log(err)});
        },
        filterChange(){
            this.addFiltersToUrl(this.activeFilters, this.$route);
            this.$emit('filter-change', {...this.activeFilters});
        },
        setFiltersFromUrl(){
            this.activeFilters = this.getFiltersFromUrl();
            this.filterChange();
        }
    },
    created() {
        this.getLayout();
    },
    watch: {
        updateFilters(value) {
            if(value) {
                this.getLayout();
                this.$store.commit('setUpdateAttributesFilters', false);
            }
        }
    }

}
</script>

<style scoped>

</style>
